import { createContext, useContext, useState, ReactNode } from 'react';

interface BottomNavVisibilityContextType {
  isHidden: boolean;
  setHidden: (hidden: boolean) => void;
}

const BottomNavVisibilityContext = createContext<BottomNavVisibilityContextType>({
  isHidden: false,
  setHidden: () => {},
});

export function BottomNavVisibilityProvider({ children }: { children: ReactNode }) {
  const [isHidden, setHidden] = useState(false);

  return (
    <BottomNavVisibilityContext.Provider value={{ isHidden, setHidden }}>
      {children}
    </BottomNavVisibilityContext.Provider>
  );
}

export function useBottomNavVisibility() {
  return useContext(BottomNavVisibilityContext);
}
